import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { MagnifyingGlassMinusSVG } from '@common_components/svg/magnifyingGlassMinus.svg';

const MagnifyingGlassMinusIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <MagnifyingGlassMinusSVG/>
    </div>
  );
};

export { MagnifyingGlassMinusIcon };
